import { isInsightsError } from '../errors/InsightsError';
const sampleRateConfig = {
    defaultSampleRate: 0.2,
    errCodeSampleRates: {},
    messageSampleRates: {},
    levelSampleRates: {}
};
export const setDefaultSampleRate = (sampleRate) => {
    sampleRateConfig.defaultSampleRate = sampleRate;
};
export const setErrCodeSampleRate = (errCode, sampleRate) => {
    sampleRateConfig.errCodeSampleRates[errCode] = sampleRate;
};
export const setMessageSampleRate = (message, sampleRate) => {
    sampleRateConfig.messageSampleRates[message] = sampleRate;
};
export const setLevelSampleRate = (severityLevel, sampleRate) => {
    sampleRateConfig.levelSampleRates[severityLevel] = sampleRate;
};
/**
 * Decides if an event is sampled based on several factors in the following order:
 *
 * Error has a sampleRate set. Must use InsightsError for this to work.
 * Error has a code and the code sample rate has been configured using setErrCodeSampleRate. Must use InsightsError for this to work.
 * The event is a message and the message sample rate has been configured using setMessageSampleRate.
 * The event's severity level's sample rate has been configured using setLevelSampleRate.
 * Default sample rate (0.2 unless overriden with setDefaultSampleRate)
 *
 * Use this in Sentry's `beforeSend` hook, i.e.
 * beforeSend: (event) => sampleEvent(event)
 *
 * @param event ErrorEvent
 * @returns ErrorEvent | null
 */
export const sampleEvent = (event) => {
    var _a;
    const { defaultSampleRate, errCodeSampleRates, messageSampleRates, levelSampleRates } = sampleRateConfig;
    let sampleRate = defaultSampleRate;
    // Requires Sentry's ExtraErrorData integration to work.
    const error = (_a = event.contexts) === null || _a === void 0 ? void 0 : _a.Error;
    if (error && isInsightsError(error)) {
        const errSampleRate = error.sampleRate;
        const errCode = error.code;
        if (typeof errSampleRate === 'number') {
            sampleRate = errSampleRate;
        }
        else if (errCode && errCodeSampleRates.hasOwnProperty(errCode)) {
            sampleRate = errCodeSampleRates[errCode];
        }
    }
    else if (event.message && messageSampleRates.hasOwnProperty(event.message)) {
        sampleRate = messageSampleRates[event.message];
    }
    else if (event.level && levelSampleRates.hasOwnProperty(event.level)) {
        sampleRate = levelSampleRates[event.level];
    }
    if (Math.random() < sampleRate) {
        return event;
    }
    return null;
};
